import { render, staticRenderFns } from "./AppRouterView.vue?vue&type=template&id=7b582432&scoped=true&"
import script from "./AppRouterView.vue?vue&type=script&lang=js&"
export * from "./AppRouterView.vue?vue&type=script&lang=js&"
import style0 from "./AppRouterView.vue?vue&type=style&index=0&id=7b582432&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b582432",
  null
  
)

export default component.exports